module.exports = __webpack_public_path__ + "img/bb.bb12aed0.png";